// Shared styles. Colours come from the CSS tokens in index.css, so they follow light/dark mode.
const token = (name: string) => `var(--joan-${name})`;

export const BRAND = {
  // Pink stays the same in both modes: primary actions, links, active states
  pink: '#EA5480',
  pinkHover: '#D03E6A',
  onPink: '#FFFFFF',

  ink: token('ink'),
  muted: token('muted'),
  faint: token('faint'),
  line: token('line'),
  lineStrong: token('line-strong'),
  accent: token('accent'),
  accentSoft: token('positive-soft'),
  warning: token('warning'),
  warningSoft: token('warning-soft'),
  danger: token('danger'),

  panel: token('panel'),
  header: token('header'),
  card: token('card'),
  inset: token('inset'),
  dialog: token('dialog'),
  hover: token('hover'),
  selected: token('selected'),
  fieldFill: token('field-fill'),
  veilStrong: token('veil-strong'),
  veilSoft: token('veil-soft'),
  veilFull: token('veil-full'),
  heroShadow: token('hero-shadow'),
  shadow: token('shadow'),
};

// Frosted-glass surfaces over the background photo
export const frostedSx = {
  backdropFilter: 'blur(13px)',
  WebkitBackdropFilter: 'blur(13px)',
};

// Text fields take their colours from the theme; this only keeps a shared hook for tweaks
export const fieldSx = {};

export const primaryButtonSx = {
  backgroundColor: BRAND.pink,
  color: BRAND.onPink,
  px: 4,
  '&:hover': { backgroundColor: BRAND.pinkHover },
  '&.Mui-disabled': { backgroundColor: 'rgba(234, 84, 128, 0.45)', color: 'rgba(255, 255, 255, 0.85)' }
};

export const outlineButtonSx = {
  color: BRAND.ink,
  borderColor: BRAND.lineStrong,
  '&:hover': { borderColor: BRAND.ink, backgroundColor: BRAND.hover },
  '&.Mui-disabled': { color: BRAND.faint, borderColor: BRAND.line }
};

export const textButtonSx = {
  color: BRAND.ink,
  '&:hover': { backgroundColor: BRAND.hover }
};

export const dialogPaperProps = {
  sx: { maxWidth: 500 }
};

export const glassCardSx = {
  ...frostedSx,
  backgroundColor: BRAND.card,
  color: BRAND.ink,
  border: `1px solid ${BRAND.line}`,
  borderRadius: '13px',
  boxShadow: BRAND.shadow,
  p: { xs: 3, sm: 4 },
  mb: 3
};
